import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-base-shared',
  template: `
    <p>
      base-shared works!
    </p>
  `,
  styles: [
  ]
})
export class BaseSharedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
